import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import FileLoader from "utils/components/FileLoader";
import { makeStyles } from "@material-ui/core/styles";
import CheckboxQuestion from "components/CheckboxQuestion";
import RadioGroupQuestion from "components/RadioGroupQuestion";
import DropdownQuestion from "components/DropdownQuestion";
import { DataStore } from "@aws-amplify/datastore";
import { Auth } from "aws-amplify";
import { EyepieceTwoResponse, Users } from "models";
const useStyles = makeStyles((theme) => ({

  paper: {

    paddingBottom: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  paperContent:{
    position: "absolute",
    width: "100%",
    left: 0,
    height: "100%",
    top: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  image:{
    // objectFit: "cover",
    maxWidth: "100%",
    // left: 0,
    maxHeight:"100%",
    height: "auto",
    // top: 0,
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center"
  },
  dragging: {
    background: "lightgray",
    opacity: 0.8,
  },
  form: {
      marginLeft:"40px",
    height: "60vh",
    overflowY: "auto",
  },
}));

function EyepieceTwoSurvey() {
  const classes = useStyles();
  const [user, setUser] = useState(null);
  const [school, setSchool] = useState(null);
  const [dragging, setDragging] = useState(false); // to show a dragging effect
  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState(""); // to show an error message
  const [message, setMessage] = useState(""); // to show an error message


  useEffect(async () => {
    const user = await Auth.currentAuthenticatedUser();
    console.log('user', user);
    const users = await DataStore.query(Users, (d) =>
      d.email("eq", user.attributes.email)
    );
    
    console.log('users', users);
    const school = users[0].school;
    setUser(user);
    setSchool(school);
  }, []);

  const [questions, setQuestions] = useState([
    {
      question: "GradeLevel",
      type: "dropdown",
      selected: "",
      options: [
        { label: "PK" },
        { label: "K" },
        { label: "1" },
        { label: "2" },
        { label: "3" },
        { label: "4" },
        { label: "5" },
        { label: "6" },
        { label: "7" },
        { label: "8" },
        { label: "9" },
        { label: "10" },
        { label: "11" },
        { label: "12" },
      ],
    },
    {
      question: "StudentGender",
      type: "radiogroup",
      selected: "",
      options: [
        { label: "Male" },
        { label: "Female" },
        { label: "Non-binary" },
      ],
    },
    {
      question: "Technology Depicted",
      type: "checkbox",
      options: [
        { label: "Laptop", checked: false },
        { label: "Phone", checked: false },
        { label: "Ipad/tablet", checked: false },
        { label: "Desktop", checked: false },
        { label: "Paper/pencil", checked: false },
      ],
    },
    {
      question: "Student Affect",
      type: "checkbox",
      options: [
        { label: "Positive", checked: false },
        { label: "Negative", checked: false },
        { label: "Neutral", checked: false },
        { label: "Cannot discern", checked: false },
        { label: "No student depicted", checked: false },
      ],
    },
    {
      question: "Subject Depicted",
      type: "checkbox",
      options: [
        { label: "Math", checked: false },
        { label: "ELA", checked: false },
        { label: "Science", checked: false },
        { label: "SS/History/Geo", checked: false },
        { label: "Arts/Music", checked: false },
        { label: "PE/Gym", checked: false },
      ],
    },
    {
      question: "Workspace Depicted",
      type: "checkbox",
      options: [
        { label: "Desk/Table", checked: false },
        { label: "Chair", checked: false },
        { label: "Bed", checked: false },
      ],
    },
    {
      question: "Other People Depicted",
      type: "checkbox",
      options: [
        { label: "Alone", checked: false },
        { label: "Other student/sibling", checked: false },
        { label: "Mom (Female adult)", checked: false },
        { label: "Dad (Male adult)", checked: false },
      ],
    },
  ]);

  function handleFileDragEnter(e) {
    setDragging(true);
  }
  function handleFileDragLeave(e) {
    setDragging(false);
  }
  function handleFileDrop(e) {
    if (e.dataTransfer.types.includes("Files") === false) {
      return;
    }
    if (e.dataTransfer.files.length >= 1) {
      let file = e.dataTransfer.files[0];
      if (file.size > 5000000) {
        setError("File size should be less than 5 MB.");
        return;
      }
      if (file.type.match(/image.*/)) {
        let reader = new FileReader();
        reader.onloadend = (e) => {
          // TODO: call setPhoto with e.target.result (this is a Base64 image string)
          setPhoto(e.target.result);
        };
        reader.readAsDataURL(file);
      }else{
        setError("File type should be an image");
      }
    }
    setDragging(false);
  }
  function handleSubmit(e) {}
  function handleCheckboxChange(questionIndex, optionIndex, checked) {
    setQuestions(
      questions.map((q, i) => {
        if (i !== questionIndex) {
          return q;
        }
        return {
          ...q,
          options: q.options.map((o, j) => {
            if (j !== optionIndex) {
              return o;
            }
            return {
              ...o,
              checked,
            };
          }),
        };
      })
    );
  }
  function handleSelectionChange(questionIndex, selected) {
    setQuestions(
      questions.map((q, i) => {
        if (i !== questionIndex) {
          return q;
        }
        return {
          ...q,
          selected,
        };
      })
    );
  }
  async function handleSubmit() {
    const incomplete = questions.some((q) => {
      if (q.question === "GradeLevel" || q.question === "StudentGender") {
        return q.selected === "";
      }
      return false
    });
    if (!photo) {
      setError("Please add a student drawing.");
      return;
    }
    if (incomplete) {
      setError("Please fill out every question.");
      return;
    }
    setError("");

    await DataStore.save(
      new EyepieceTwoResponse({
        username: user.username,
        name: user.attributes.name,
        email: user.attributes.email,
        school: school,
        questions: JSON.stringify(questions),
        photo:photo
      })
    );
    setMessage("Successfully submitted! Please feel free to submit an additional drawing.")
    setTimeout(function(){ 
        setMessage("")
    }, 5000);
    setPhoto(null);
    setQuestions(
        questions.map((q) => {
            if (q.type === "checkbox") {
                return {
                    ...q,
                    options: q.options.map(o=> ({
                        ...o,
                        checked: false,
                    }))
                }
            }
            return {
                ...q,
                selected: ""
            }
        })
    )
  }

  return (
    <Grid container spacing={4} className={classes.container}>
      <Grid item xs={5}>
        <FileLoader
          onDragEnter={handleFileDragEnter}
          onDragLeave={handleFileDragLeave}
          onDrop={handleFileDrop}
        >
          <Paper
            className={[classes.paper, dragging ? classes.dragging : null].join(
              " "
            )}
          >
              <Box className={classes.paperContent}>
              {!photo ? (
              <Typography variant="overline">
                Drop a drawing image to upload
              </Typography>
            ) : (
              <img className={classes.image} src={photo} alt="student drawing" />
            )}
              </Box>
            
          </Paper>
        </FileLoader>
      </Grid>
      <Grid item xs={7}>
        <Box className={classes.form}>
          {questions.map((q, i) => {
            switch (q.type) {
              case "dropdown":
                return (
                  <DropdownQuestion
                    key={i}
                    question={q.question}
                    options={q.options}
                    selected={q.selected}
                    onChange={handleSelectionChange.bind(this, i)}
                  />
                );

              case "checkbox":
                return (
                  <CheckboxQuestion
                    key={i}
                    question={q.question}
                    options={q.options}
                    onChange={handleCheckboxChange.bind(this, i)}
                  />
                );
              case "radiogroup":
                return (
                  <RadioGroupQuestion
                    key={i}
                    question={q.question}
                    options={q.options}
                    selected={q.selected}
                    onChange={handleSelectionChange.bind(this, i)}
                  />
                );
            }
          })}
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box p={3}>
          <Typography variant="subtitle1" color="error">
            {error}
          </Typography>
          <Typography variant="subtitle1" color="primary">
            {message}
          </Typography>
        </Box>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          className={classes.button}
          endIcon={<SendIcon />}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
}

export default EyepieceTwoSurvey;
